import PremiumFoldersEmptyState from './PremiumFoldersEmptyState';
import PremiumFoldersEmptyStateContainer from './PremiumFoldersEmptyState.container';

export default PremiumFoldersEmptyStateContainer(PremiumFoldersEmptyState);
